/**
 * CZNA-1340 — saves what one subfield means in its field:
 * `PUT /czna-authorities/subfield-descriptions/{tag}/{code}`.
 *
 * Only NK's authority admin holds the permission; anyone else gets 403 from the sidecar, and
 * the browser hides the edit button from them in the first place (`canEdit` in the caller).
 * On success the shared help-texts query is invalidated, because that one response is where
 * the record form reads the description from.
 */
import { useOkapiKy } from '@folio/stripes/core';
import { useMutation, useQueryClient } from 'react-query';
import { getHeaders } from '../api/apiUtils';
import { helpTextsQueryKey } from './useHelpTexts';
export var SUBFIELD_DESCRIPTION_PATH = function (tag, code) { return ("czna-authorities/subfield-descriptions/".concat(encodeURIComponent(tag), "/").concat(encodeURIComponent(code))); };
var useSaveSubfieldDescription = function (options) {
    if (options === void 0) { options = {}; }
    // Closure-capture only. MEMORY: ky is unstable — never in deps.
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation(function (_a) {
        var tag = _a.tag, code = _a.code, description = _a.description, source = _a.source;
        return ky
            .put(SUBFIELD_DESCRIPTION_PATH(tag, code), {
            json: { description: description, source: source },
            headers: getHeaders(),
        })
            .json();
    }, {
        onSuccess: function () {
            var _a;
            queryClient.invalidateQueries(helpTextsQueryKey);
            (_a = options.onSuccess) === null || _a === void 0 ? void 0 : _a.call(options);
        },
    });
};
export default useSaveSubfieldDescription;
